<template>
  <div class="fl-qr-code">
    <div class="header">
      <fn-picture
        class="fl-logo"
        :src="logoData.intro_friends_image.url"
        :alt="logoData.intro_friends_image.alt"
        :title="logoData.intro_friends_image.title"
        :width="logoData.intro_friends_image.width"
        :height="logoData.intro_friends_image.height"
      />

      <div class="country-data">
        <div class="country-icon">
          <fn-picture
            class="fl-logo"
            :src="countryIconSrc"
            :alt="$t('friendsLight.flagIcon.alt')"
            :title="$t('friendsLight.flagIcon.title')"
            :width="16"
            :height="16"
          />
        </div>

        <div class="country-code">
          {{ qrCode }}
        </div>
      </div>
    </div>

    <fn-toast
      :show="isToastVisible"
      :header="$t('friendsLight.toast.success.headline')"
      :text="$t('friendsLight.toast.success.text')"
      type="success"
    />

    <div class="qr-code-wrapper">
      <fn-qr-code
        class="qr-code"
        :text="qrCode"
        :size="qrCodeOptions.size"
        :color="qrCodeOptions.color"
        :bg-color="qrCodeOptions.bgColor"
        :error-level="qrCodeOptions.errorLevel"
      />
    </div>

    <div class="user-email">
      {{ displayUid }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    qrCodeOptions: {
      type: Object,
      required: true,
    },
    logoData: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isToastVisible: false,
    toast: {
      type: 'success',
      header: '',
      text: '',
    },
  }),
  computed: {
    ...mapState(useMainStore, {
      defaultCountry: 'defaultCountry',
    }),
    ...mapState(useUserStore, {
      user: 'user',
      qrCode: 'getFriendsLightQrCode',
    }),
    displayUid() {
      return this.user?.displayUid;
    },
    countryIconSrc() {
      switch (this.defaultCountry) {
        case 'AT':
          return '/img/icon-flag-austria.svg';
        case 'DE':
          return '/img/icon-flag-germany.svg';
        case 'FR':
          return '/img/icon-flag-france.svg';
        default:
          return '';
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isToastVisible = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.fl-qr-code {
  display: flex;
  flex-direction: column;
  max-width: 542px;
  width: 100%;
  padding: $pad;
  background-color: $color-general-background-neutral-default;
  position: absolute;
  top: $ui-height;
  z-index: 3;
  border-radius: none;

  @include bp(xxs) {
    top: -32px;
  }

  @include bp(xs) {
    border-radius: map-get($border-radiuses, 'xxl');
  }

  @include bp(m) {
    box-shadow: map-get($box-shadows, 'friends-light');
    padding: calc(#{$pad} * 2) calc(#{$pad} * 1.5);
    top: 64px;
  }

  .header {
    display: flex;
    justify-content: space-between;

    .fl-logo {
      width: 125px;
      max-width: 200px;

      @include bp(m) {
        width: 100%;
      }
    }

    .country-data {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;

      .country-icon {
        display: flex;
        align-items: center;
        max-width: $pad;
        max-height: $pad;
      }

      .country-code {
        margin-left: math.div($pad, 4);
      }
    }
  }

  .qr-code-wrapper {
    border: map-get($border-width, 'xs') solid black;
    border-radius: calc(#{map-get($border-radiuses, 'xxl') * 1.2});
    align-self: center;
    margin: $pad * 2 0;
    padding: $pad;

    @include bp(m) {
      margin: $ui-height 0;
    }
  }

  .user-email {
    align-self: center;
    width: 100%;
    max-width: 375px;
    padding: math.div($pad, 2) 0;
    padding-left: $pad * 1.5;
    background-color: palette(grey, lighter);
    border-radius: map-get($border-radiuses, 'xl');
  }
}
</style>
